module.exports = __webpack_public_path__ + "static/media/logo.09617a5b.svg";